export const JSON_ONE99990NW = [
  {
    publishId: "7GP-092723131500-290",
    meId: "202309210004",
    Data: {
      AuthRR: [],
      AuthVRR: [],
      CaptureRR: [],
      SaleRR: [],
      RefundRI: [],
      RequestSTPGoB: [],
      ResponseRFPGoB: [],
      VerificationRSTPGoB: [],
      VerificationRRFPGoB: [],
      NoRRFPGoB: [],
      AuthRP: [],
      AuthRF: [],
      AuthVRP: [],
      AuthVRF: [],
      CaptureRP: [],
      CaptureRF: [],
      SaleRP: [],
      SaleRF: [
        {
          agRef: "2058881695804289650",
          pgRef: "",
          orderNo: "Testing2",
          amount: "1000.00",
          status: "03",
          txnDate: "2023-09-27T13:13:51.720",
        },
      ],
      RefundRP: [],
      RefundRF: [],
      ReconciledWRGoB: [],
      SettlementD: [],
      ReconciledM: [],
      MerchantPD: [],
      CancelledBC: [],
      Aborted: [],
      HostTO: [],
      AmountM: [],
    },
  },
];
